import { makeAutoObservable } from "mobx";

export default class RolesAndPermissionStore {
  showPopup: boolean;
  title: string;
  message: string;
  hasViewRights: boolean;
  hasManageRights: boolean;
  constructor() {
    makeAutoObservable(this);
    this.showPopup = false;
    this.title = "Insufficient Rights to Perform this Action";
    this.message = "No Message";
    this.hasViewRights = true;
    this.hasManageRights = true;
  }

  setPermissions(hasViewRights: boolean, hasManageRights: boolean) {
    this.hasViewRights = hasViewRights;
    this.hasManageRights = hasManageRights;
  }

  hasPermission(
    key: string,
    showPopup?: boolean,
    message?: string,
    title?: string
  ): boolean {
    let hasPermission = true;
    switch (key) {
      case "view":
        hasPermission = this.hasViewRights;
        break;
      case "manage":
        hasPermission = this.hasManageRights;
        break;
    }
    if (!hasPermission && showPopup) {
      this.showPopup = true;
      this.title = title || "Insufficient Rights to Perform this Action";
      this.message = message || "No Message";
    }
    return hasPermission;
  }

  hasManagePermission(message?: string, showPopup: boolean = true, title?: string) {
    return this.hasPermission("manage", showPopup, message, title);
  };

  hasViewPermission(showPopup?: boolean, message?: string, title?: string) {
    return this.hasPermission("view", showPopup, message, title);
  };

  togglePermissionPopup(showPopup: boolean) {
    this.showPopup = showPopup;
  }
}
